<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model" @show="onShow" :title="computedTitle"
                   @hidden="onHidden" :show-confirmation="showConfirmation" @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-12">
          <currency-input-widget :model="model" attribute="lot_handling_charge"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import LotsService from "@/modules/lots/LotsService";
  import {SOURCE_LOTS_TABLE, WS_BATCH_UPDATE_LOT_FINANCIAL_TERMS} from "@/modules/constants";
  import BatchFinancialUpdateModel from "@/modules/lots/batch-financial-update/BatchFinancialUpdateModel.model";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('lots');
  const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');
  export default {
    name: "BatchFinancialUpdateModal",
    components: {
      CurrencyInputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new BatchFinancialUpdateModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.batchFinancialUpdateModal,
        reservations: state => state.batchFinancialUpdateModal.reservations
      }),
      computedTitle() {
        return this.$i18n.t("Batch Financial Update")
      }
    },
    methods: {
      ...mapActionsGlobal(['addProgress', 'removeProgress', 'updateProgressValue']),
      ...mapActions(['hideBatchFinancialUpdateModal', 'getTableData']),
      onShow() {
        this.showConfirmation = true;
        this.model = new BatchFinancialUpdateModel();
      },
      onHidden() {
        this.hideBatchFinancialUpdateModal();
      },
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }
        let requestData = {
          lot_handling_charge: this.model.lot_handling_charge,
          lot_uuids: this.reservations.map(r => r.lot.uuid)
        }

        this.showConfirmation = false
        let response = await LotsService.batchFinancialUpdate(requestData)
        if (response.success) {
          if (this.modal.source === SOURCE_LOTS_TABLE) {
            this.$toast('success', this.$i18n.t("Lots Financial Update has started."))
            this.$ws.listen(`sales.${WS_BATCH_UPDATE_LOT_FINANCIAL_TERMS}`, this.onProgressNotificationReceive);
            this.hideBatchFinancialUpdateModal()
          }
        } else {
          this.showConfirmation = true
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          }
        }
      },
      async onProgressNotificationReceive(data) {
        await this.addProgressIfNotExist(data.task_id, data.sale_no)
        this.updateProgressValue({
          progressValue: parseInt(Math.round(data.successful / data.total * 100)),
          uuid: this[data.task_id].uuid
        });

        if (data.is_finished) {
          if (data.error) {
            this.$errorDialog(data.error)
          } else {
            this.$toast('success', this.$i18n.t("Batch Lots Financial Update has successfully finished for sale {sale_no}", {'sale_no': data.sale_no}));
            this.getTableData()
          }
          this.removeProgressIfExist(data.task_id);
        }
      },
      async addProgressIfNotExist(taskId, sale_no) {
        if (!this[taskId]) {
          this[taskId] = await this.addProgress(this.$i18n.t("Batch Lots Financial Update for sale {sale_no}", {'sale_no': sale_no}));
        }
      },
      removeProgressIfExist(taskId) {
        if (this[taskId]) {
          this.removeProgress(this[taskId].uuid);
          this[taskId] = null;
        }
      },
      beforeDestroy() {
        this.$ws.remove(`sales.${WS_BATCH_UPDATE_LOT_FINANCIAL_TERMS}`);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
